







import { Component, Vue, Prop } from 'vue-property-decorator';
import CostsDetails from '@/components/CostsDetails.vue';
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'Costs',
    components: {
        CostsDetails,
        NotLoggedPanel
    }
})
export default class Costs extends Vue {
    @Prop() private user!: User;
}
